/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SortedIndices
 */
export interface SortedIndices {
  /**
   *
   * @type {Array<number>}
   * @memberof SortedIndices
   */
  sortedPositions: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof SortedIndices
   */
  cspPositions: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof SortedIndices
   */
  nonCspPositions: Array<number>;
  /**
   *
   * @type {{ [key: string]: Array<number>; }}
   * @memberof SortedIndices
   */
  positionsByCarrier: { [key: string]: Array<number> };
  /**
   *
   * @type {{ [key: string]: Array<number>; }}
   * @memberof SortedIndices
   */
  cspPositionsByCarrier: { [key: string]: Array<number> };
  /**
   *
   * @type {{ [key: string]: Array<number>; }}
   * @memberof SortedIndices
   */
  nonCspPositionsByCarrier: { [key: string]: Array<number> };
}

/**
 * Check if a given object implements the SortedIndices interface.
 */
export function instanceOfSortedIndices(value: object): value is SortedIndices {
  if (!("sortedPositions" in value) || value["sortedPositions"] === undefined)
    return false;
  if (!("cspPositions" in value) || value["cspPositions"] === undefined)
    return false;
  if (!("nonCspPositions" in value) || value["nonCspPositions"] === undefined)
    return false;
  if (
    !("positionsByCarrier" in value) ||
    value["positionsByCarrier"] === undefined
  )
    return false;
  if (
    !("cspPositionsByCarrier" in value) ||
    value["cspPositionsByCarrier"] === undefined
  )
    return false;
  if (
    !("nonCspPositionsByCarrier" in value) ||
    value["nonCspPositionsByCarrier"] === undefined
  )
    return false;
  return true;
}

export function SortedIndicesFromJSON(json: any): SortedIndices {
  return SortedIndicesFromJSONTyped(json, false);
}

export function SortedIndicesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SortedIndices {
  if (json == null) {
    return json;
  }
  return {
    sortedPositions: json["sortedPositions"],
    cspPositions: json["cspPositions"],
    nonCspPositions: json["nonCspPositions"],
    positionsByCarrier: json["positionsByCarrier"],
    cspPositionsByCarrier: json["cspPositionsByCarrier"],
    nonCspPositionsByCarrier: json["nonCspPositionsByCarrier"],
  };
}

export function SortedIndicesToJSON(json: any): SortedIndices {
  return SortedIndicesToJSONTyped(json, false);
}

export function SortedIndicesToJSONTyped(
  value?: SortedIndices | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    sortedPositions: value["sortedPositions"],
    cspPositions: value["cspPositions"],
    nonCspPositions: value["nonCspPositions"],
    positionsByCarrier: value["positionsByCarrier"],
    cspPositionsByCarrier: value["cspPositionsByCarrier"],
    nonCspPositionsByCarrier: value["nonCspPositionsByCarrier"],
  };
}
